'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactChartjs = require('react-chartjs-2');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chartStyles = {
  width: '100%'
};

var getChartOptions = function getChartOptions(_ref) {
  var rgbColorCode = _ref.rgbColorCode,
      suggestedMax = _ref.suggestedMax,
      suggestedMin = _ref.suggestedMin;
  return {
    responsive: true,
    showScale: false,
    tooltips: {
      enabled: true,
      mode: 'single',
      callbacks: {
        label: _formatting.getGraphLabelFormatting
      }
    },
    legend: {
      labels: {
        usePointStyle: true,
        fontSize: 12
      }
    },
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false
        }
      }],
      yAxes: [{
        id: 'followers',
        type: 'linear',
        position: 'left',
        stacked: false,
        gridLines: {
          display: false
        },
        ticks: {
          // eslint-disable-next-line
          callback: function callback(label, index, labels) {
            return (0, _formatting.scientificFormatted)(label);
          },

          fontColor: rgbColorCode,
          suggestedMin: suggestedMin,
          suggestedMax: suggestedMax
        }
      }]
    }
  };
};

var FollowersBarChart = function FollowersBarChart(_ref2) {
  var label = _ref2.label,
      labels = _ref2.labels,
      values = _ref2.values,
      _ref2$rgbColorCode = _ref2.rgbColorCode,
      rgbColorCode = _ref2$rgbColorCode === undefined ? '#fc4085' : _ref2$rgbColorCode,
      percentageRange = _ref2.percentageRange;

  var data = {
    labels: labels,
    datasets: [{
      label: label,
      type: 'line',
      backgroundColor: rgbColorCode + '11',
      borderColor: rgbColorCode,
      borderCapStyle: 'butt',
      borderJoinStyle: 'miter',
      borderWidth: 2,
      fill: false,
      data: values
    }]
  };

  var suggestedMax = void 0;
  var suggestedMin = void 0;

  if (percentageRange) {
    var calculatedIncrement = _lodash2.default.mean(values) / 100 * percentageRange;
    suggestedMin = _lodash2.default.min(values) - calculatedIncrement;
    suggestedMax = _lodash2.default.max(values) + calculatedIncrement;
  }

  var options = getChartOptions({ rgbColorCode: rgbColorCode, suggestedMax: suggestedMax, suggestedMin: suggestedMin });
  return _react2.default.createElement(_reactChartjs.Bar, {
    style: chartStyles,
    data: data,
    options: options
  });
};

exports.default = FollowersBarChart;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/followers-bar-chart/index.js
 ** module id = 177
 ** module chunks = 0
 **/